import c1 from './fw/fw_1.webp';
import c2 from './fw/fw_2.webp';
import c3 from './fw/fw_3.webp';
import c4 from './fw/fw_4.webp';
import c5 from './fw/fw_5.webp';
import c6 from './fw/fw_6.webp';
import c7 from './fw/fw_7.webp';
import c8 from './fw/fw_8.webp';
import c9 from './fw/fw_9.webp';
import c10 from './fw/fw_10.webp';
import c11 from './fw/fw_11.webp';
import c12 from './fw/fw_12.webp';
import c13 from './fw/fw_13.webp';
import c14 from './fw/fw_14.webp';
import c15 from './fw/fw_15.webp';
import c16 from './fw/fw_16.webp';
import c17 from './fw/fw_17.webp';
import c18 from './fw/fw_18.webp';
import c19 from './fw/fw_19.webp';
import c20 from './fw/fw_20.webp';
import c21 from './fw/fw_21.webp';
import c22 from './fw/fw_22.webp';
import c23 from './fw/fw_23.webp';
import c24 from './fw/fw_24.webp';
import c25 from './fw/fw_25.webp';
import c26 from './fw/fw_26.webp';
import c27 from './fw/fw_27.webp';
import c28 from './fw/fw_28.webp';
import c29 from './fw/fw_29.webp';
import c30 from './fw/fw_30.webp';
import c31 from './fw/fw_31.webp';
import c32 from './fw/fw_32.webp';
import c33 from './fw/fw_33.webp';
import c34 from './fw/fw_34.webp';
import c35 from './fw/fw_35.webp';
import c36 from './fw/fw_36.webp';
import c37 from './fw/fw_37.webp';
import c38 from './fw/fw_38.webp';
import c39 from './fw/fw_39.webp';
import c40 from './fw/fw_40.webp';
import c41 from './fw/fw_41.webp';
import c42 from './fw/fw_42.webp';
import c43 from './fw/fw_43.webp';
import c44 from './fw/fw_44.webp';
import c45 from './fw/fw_45.webp';
import c46 from './fw/fw_46.webp';
import c47 from './fw/fw_47.webp';
import c48 from './fw/fw_48.webp';
import c49 from './fw/fw_49.webp';
import c50 from './fw/fw_50.webp';
import c51 from './fw/fw_51.webp';
import c52 from './fw/fw_52.webp';
import c53 from './fw/fw_53.webp';
import c54 from './fw/fw_54.webp';
import c55 from './fw/fw_55.webp';
import c56 from './fw/fw_56.webp';
import c57 from './fw/fw_57.webp';
import c58 from './fw/fw_58.webp';
import c59 from './fw/fw_59.webp';
import c60 from './fw/fw_60.webp';
import c61 from './fw/fw_61.webp';
import c62 from './fw/fw_62.webp';
import c63 from './fw/fw_63.webp';
import c64 from './fw/fw_64.webp';
import c65 from './fw/fw_65.webp';
import c66 from './fw/fw_66.webp';
import c67 from './fw/fw_67.webp';
import c68 from './fw/fw_68.webp';
import c69 from './fw/fw_69.webp';
import c70 from './fw/fw_70.webp';

const fwImg = [
	c1,
	c2,
	c3,
	c4,
	c5,
	c6,
	c7,
	c8,
	c9,
	c10,
	c11,
	c12,
	c13,
	c14,
	c15,
	c16,
	c17,
	c18,
	c19,
	c20,
	c21,
	c22,
	c23,
	c24,
	c25,
	c26,
	c27,
	c28,
	c29,
	c30,
	c31,
	c32,
	c33,
	c34,
	c35,
	c36,
	c37,
	c38,
	c39,
	c40,
	c41,
	c42,
	c43,
	c44,
	c45,
	c46,
	c47,
	c48,
	c49,
	c50,
	c51,
	c52,
	c53,
	c54,
	c55,
	c56,
	c57,
	c58,
	c59,
	c60,
	c61,
	c62,
	c63,
	c64,
	c65,
	c66,
	c67,
	c68,
	c69,
	c70,
];

export default fwImg;
